import CommonModal from "component/Common/CommonModal"
import InputBox from "component/Common/InputBox"
import Table from "component/Common/Table"
import { formatKey, isValidDate } from "helpers"
import { calenderDetailsforSurePass } from "helpers/constant"
import moment from "moment/moment"
import React, { useEffect, useState } from "react"
import "react-datepicker/dist/react-datepicker.css"

import {  useDispatch, useSelector } from "react-redux"
import { request } from "service"
import { downloadReportsTableHeader } from "service/constant"
import endpoints from "service/endpoints"
import "./styles.scss" // Importing CSS for styling

import {  Switch } from "@mui/material"
import { useLocation } from "react-router-dom/cjs/react-router-dom.min"
import CustomDatePickers from "../DatePicker/CustomeNewDate"
import { DownloadDumpSwitchFilter } from "redux/action/ReportPage"
import { icons } from "helpers/images"

const DownloadList = ({isPosReport}) => {
  const dispatch=useDispatch()
  const location = useLocation()

  const downloadReports = useSelector(
    (state) => state?.ReportPage?.downloadReports
  )

  const [download, setDownloadData] = useState([])
  const [show, setShow] = useState(false)
  // const [inboxActivePage, setInboxActivePage] = useState(1)
  const [inboxPageCount, setInboxPageCount] = useState(1)
  const [inboxVal, setInboxVal] = useState("")
  const [filterOptions, setFilterOptions] = useState([])
  const [search, setSearch] = useState()

  const [dates, setDates] = useState(calenderDetailsforSurePass);
  const isReportSwitch = useSelector(
    (state) => state?.ReportPage?.downloadDumpSwitchIsReport
  );

  const downloadList = () => {
console.log(isReportSwitch)
    let startDate = dates?.startDate
      ? moment(dates?.startDate).format("YYYY-MM-DD")
      : ""

    let endDate = dates?.endDate
      ? moment(dates?.endDate).format("YYYY-MM-DD")
      : ""
    let datum = {
      page: dates?.activePage,
      limit: 10,
      search: search,
      startDate: startDate,
      endDate: endDate,

      }
    if(isPosReport){
      datum.category="posReports"
    }
    else{
      datum.category= isReportSwitch ? "ReferralReports" : "NormalReports";
    }
    request({
      url: endpoints.reportModule.downloadExcel,
      baseUrl: "reports",
      params: datum,
      method: endpoints.APIMethods.GET,
    }).then((response) => {
      setDownloadData(response?.data?.data?.list)
      setInboxPageCount(response?.data?.data?.pageMeta?.totalPages)

      setDates((prev) => ({
        ...prev,
        activePage: response?.data?.data?.pageMeta?.page,
      }))
    })
  }

  const downloadListFilter = (index) => {

    setFilterOptions(download[index]?.filter)
  }

  useEffect(() => {
    downloadList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dates?.activePage, search, dates?.endDate, isReportSwitch]);

  const onChange = async (dates) => {
    await setDates((prev) => ({
      ...prev,
      activePage: 1,
    }))
    if (Array.isArray(dates)) {
      // This is for range selection (when `isCustomeDatePickerSidebar` is true)
      const [start, end] = dates
      setDates((prev) => ({
        ...prev,
        startDate: start,
        endDate: end,
      }))
    } else {
      // This is for single date selection (when `isCustomeDatePickerSidebar` is false)
      setDates((prev) => ({
        ...prev,
        startDate: dates, // For single date picker, only the startDate is used
        endDate: null, // Clear endDate
      }))
    }
  }

  const handleToDownload = (item) => {
    request({
      url: `${endpoints.reportModule.maindownload}/${item?._id}`,
      baseUrl: "reports",
      responseType: "blob",
      method: endpoints.APIMethods.GET,
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const a = document.createElement("a");a.href = url;
      a.download = item?.fileName
      document.body.appendChild(a);
      a.click();
      a.remove();
    });
  };

  const handleClose = () => {
    setShow(false)
  }
  const getStatusType = (status) => {
    let temp = ""
    if (status === "Inprogress") {
      temp = "bgcolor_for_orange"
    } else if (status === "Success") {
      temp = "bgcolor_for_green"
    } else if (status === "Failed") {
      temp = "bgcolor_for_red"
    }
    return temp
  }

  const handleChange = (event) => {
    dispatch(DownloadDumpSwitchFilter(!isReportSwitch))
    // setChecked(!checked)
    setDates((prev) => ({
      ...prev,
      activePage: 1,
    }))
  }
  const handleToPageChange = (page) => {
    setDates((prev) => ({
      ...prev,
      activePage: page,
    }))
  }
  const handleToSearch = async (e) => {
    await setDates((prev) => ({
      ...prev,
      activePage: 1,
    }))
    setSearch(e.target.value)
  }
  return (
    <div className="download_list_container">
      <div className="d-flex justify-content-between mb-2">
      {
            !isPosReport &&
           <div className="d-flex flex-row align-items-center margin_top">
          
          <p className={`${!isReportSwitch ? "active_Report" : ""} mt-3`}>Reports</p>

          <span>
            <Switch
              checked={isReportSwitch}
              onChange={handleChange}
              inputProps={{ "aria-label": "controlled" }}
            />
          </span>
          <p className={`${isReportSwitch ? "active_Report" : ""} mt-3`}>
            Referrel Reports
          </p>
        </div>}
        <div className="col-2 d-flex flex-column">
          <div className="date-input-feild">
            <CustomDatePickers
              onChange={onChange}
              setDates={setDates}
              dates={dates}
            />
          </div>
        </div>
        <div className="col-4">
          <InputBox.SearchBox
            name="search"
            placeholder={"Search by SubCategory"}
            onChange={(event) => handleToSearch(event)}
            value={search}
            className={`reportResultserch`}
          />
        </div>
      </div>
      <Table
        activePage={dates?.activePage}
        setactivePage={(page) => handleToPageChange(page)}
        pageCount={inboxPageCount}
        headers={downloadReportsTableHeader}
        isPagination={true}
        val={inboxVal}
        setVal={setInboxVal}
      >
        {download.length > 0 ? (
          download.map((inbox, index) => (
            <tr key={index}>
              <td style={{ whiteSpace: "nowrap" }}>
                {dates?.activePage > 1
                  ? (dates?.activePage - 1) * 10 + index + 1
                  : dates?.activePage + index}
              </td>
              <td>{moment(inbox?.createdAt).format("DD-MMM-YYYY HH:mm:ss")}</td>

              <td>{inbox?.category}</td>
              <td>{inbox?.subCategory}</td>
              <td>{inbox?.createdBy}</td>
              <td
                onClick={() => {
                  setShow(true)
                  downloadListFilter(index)
                }}
              >
                View
              </td>
              <td>
                <span className={`${getStatusType(inbox?.status)}`}>
                  {inbox?.status === "Inprogress"
                    ? " In progress"
                    : inbox?.status === "Success"
                    ? "Success"
                    : "Failed"}
                </span>
              </td>
              <td className="cursor-pointer">
                {inbox?.status === "Inprogress" ||
                  inbox?.status === "Failed" || (
                    // <LuDownload
                    //   onClick={() => handleToDownload(inbox?.fileUrl)}
                    // />
                    <img
                      height={20}
                      width={20}
                      src={icons.downloadReport}
                      alt=""
                      onClick={() => handleToDownload(inbox)}
                    />
                  )}
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td
              colSpan={downloadReportsTableHeader.length}
              style={{ textAlign: "center" }}
            >
              No records found
            </td>
          </tr>
        )}
      </Table>

      <CommonModal show={show} handleClose={handleClose} title="Filter values">
        <div className="row">
          <div className="col-12">
            {filterOptions && ( // Only render if filterOptions exists
              <div className="filter-grid">
                {Object.entries(filterOptions).map(([key, value]) => (
                  <React.Fragment key={key}>
                    <div className="filter-label">{formatKey(key)}</div>
                    <div>
                      {Array.isArray(value)
                        ? value.map((item, index) => (
                            <span className="text-break" key={index}>
                              {item}
                              {index !== value.length - 1 ? ", " : ""}
                            </span>
                          ))
                        : typeof value === "string" && isValidDate(value)
                        ? moment(value).format("DD-MM-YYYY")
                        : value || "N/A"}
                    </div>
                  </React.Fragment>
                ))}
              </div>
            )}
          </div>
        </div>
      </CommonModal>
    </div>
  )
}

export default DownloadList